import {RouteComponentProps} from '@reach/router'
import {useEffect, useState} from 'react'
import {Box} from 'reoil'
import BtnBottom from '../components/BtnBottom'
import goto from '../utils/goto'
import {homepage} from '../../package.json'

const NotFoundPage: React.FC<RouteComponentProps> = () => {
  const [countDown, setCountDown] = useState(2)

  useEffect(() => {
    if (countDown >= 0) {
      setTimeout(() => {
        setCountDown(countDown - 1)
      }, 1000)
    } else {
      goto('/')
    }
  }, [countDown])

  return (
    <Box className='404' height='100%' center>
      <svg
        viewBox='0 0 1792 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='2431'
        width='200'
        height='200'>
        <path
          d='M494.08 570c0 217.248 176.112 393.344 393.344 393.344 217.248 0 393.344-176.096 393.344-393.344 0-217.232-176.096-393.328-393.344-393.328-217.232 0-393.328 176.096-393.328 393.328z'
          fill='#949494'
          p-id='2432'></path>
        <path
          d='M887.424 176.672c-157.92 0-294.208 93.264-356.608 227.52a392.384 392.384 0 0 0-3.84 54.304c0 217.168 176.16 393.328 393.344 393.328 157.92 0 294.224-93.264 356.624-227.52 2.48-17.808 3.84-35.84 3.84-54.304 0-217.168-175.952-393.328-393.36-393.328z'
          fill='#A6A6A6'
          p-id='2433'></path>
        <path
          d='M887.424 376.48a137.648 137.648 0 1 0 275.296 0 137.648 137.648 0 1 0-275.296 0z'
          fill='#868787'
          p-id='2434'></path>
        <path
          d='M1012 255.296a136.672 136.672 0 0 0-100.688 43.92 136.384 136.384 0 0 0-23.888 77.28c0 75.92 61.728 137.648 137.648 137.648a136.672 136.672 0 0 0 100.704-43.936 136.384 136.384 0 0 0 23.888-77.28 137.632 137.632 0 0 0-137.648-137.632z'
          fill='#949494'
          p-id='2435'></path>
        <path
          d='M579.472 606.048a93.488 93.488 0 1 0 186.976 0 93.488 93.488 0 1 0-186.976 0z'
          fill='#868787'
          p-id='2436'></path>
        <path
          d='M663.952 523.6a92.8 92.8 0 0 0-68.256 29.728 93.376 93.376 0 0 0-16.224 52.496 93.552 93.552 0 0 0 93.488 93.488 92.8 92.8 0 0 0 68.256-29.728 93.376 93.376 0 0 0 16.224-52.48 93.552 93.552 0 0 0-93.488-93.504z'
          fill='#949494'
          p-id='2437'></path>
        <path
          d='M1016.96 754.288a76.16 76.16 0 0 0 152.288 0 76.16 76.16 0 0 0-152.288 0z'
          fill='#868787'
          p-id='2438'></path>
        <path
          d='M1085.904 687.152c-22.08 0-41.904 9.456-55.872 24.32a75.648 75.648 0 0 0-13.072 42.816 76.048 76.048 0 0 0 76.16 76.144c22.08 0 41.888-9.472 55.856-24.32 8.336-12.176 13.072-27.04 13.072-42.816a76.048 76.048 0 0 0-76.16-76.144z'
          fill='#949494'
          p-id='2439'></path>
        <path
          d='M810.384 800.912a45.952 45.952 0 1 0 91.92 0 45.952 45.952 0 1 0-91.92 0z'
          fill='#868787'
          p-id='2440'></path>
        <path
          d='M852.064 760.592c-13.28 0-25.232 5.632-33.568 14.64a46.096 46.096 0 0 0-7.888 25.68 46 46 0 0 0 45.952 45.968c13.296 0 25.232-5.632 33.568-14.656 4.96-7.424 7.888-16.208 7.888-25.68a46 46 0 0 0-45.952-45.952z'
          fill='#949494'
          p-id='2441'></path>
        <path
          d='M720.272 355.312a45.952 45.952 0 1 0 91.92 0 45.952 45.952 0 1 0-91.92 0z'
          fill='#868787'
          p-id='2442'></path>
        <path
          d='M761.952 314.768c-13.28 0-25.232 5.632-33.568 14.64a46.096 46.096 0 0 0-7.888 25.68 46 46 0 0 0 45.952 45.952c13.296 0 25.232-5.632 33.568-14.64 4.96-7.44 7.888-16.224 7.888-25.68-0.224-25.232-20.72-45.952-45.952-45.952z'
          fill='#949494'
          p-id='2443'></path>
        <path
          d='M1270.864 96.24a77.04 77.04 0 0 0 154.08 0 77.04 77.04 0 0 0-154.08 0zM1135.68 52.992a32 32 0 0 0 64 0 32 32 0 0 0-64 0zM427.856 977.088a32 32 0 0 0 63.984 0 32 32 0 0 0-63.984 0zM66.512 216.32a20.96 20.96 0 1 0 41.904 0 20.96 20.96 0 1 0-41.92 0z'
          fill='#999999'
          p-id='2444'></path>
        <path
          d='M218.352 812.4v-125.472H33.6v-92.144l197.12-343.104h127.968v336.8h75.68v98.448h-75.68v125.472h-140.352z m1.568-222.352v-155.2a913.904 913.904 0 0 1-24.784 55.408 1276.24 1276.24 0 0 1-33.328 62.848l-20.288 36.96h78.4zM1542.56 812.4v-125.472H1357.792v-92.144l197.12-343.104h127.968v336.8h75.68v98.448h-75.68v125.472h-140.352z m1.568-222.352v-155.2a913.904 913.904 0 0 1-24.8 55.408 1276.24 1276.24 0 0 1-33.328 62.848l-20.496 36.96h78.624z'
          fill='#A6A6A6'
          p-id='2445'></path>
      </svg>
      <p style={{marginBottom: 60, marginTop: -20, color: 'GrayText'}}>
        没有找到此页面, 即将跳转到首页~
      </p>
      <BtnBottom unFixed mb={4} maxWidth={200} onClick={() => goto('/')}>
        去首页 {countDown}s
      </BtnBottom>
    </Box>
  )
}

export default NotFoundPage
